'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('storyStat', {
      url: '/storyStat',
      template: '<story-stat></story-stat>'
    });
}



// WEBPACK FOOTER //
// ./client/app/storyStat/storyStat.routes.js